import { CoachingSessionSlot } from 'coaching/containers/GetPossibleCoachingSessionsForCoachContainer';
import { DayOfWeek } from 'globalTypes';

export type SlotsForDay = {
  [startTime: string]: CoachingSessionSlot[];
};
export type RecurringCoachingSessionSlotGroupings = Record<DayOfWeek, SlotsForDay>;

export function groupSlotsByWeekdayAndStartTime(sessionSlots: CoachingSessionSlot[]) {
  const slotsWithMetadata = sessionSlots?.map(slot => ({
    ...slot,
    weekday: slot.startDateTime.format('dddd') as DayOfWeek,
    startTime: slot.startDateTime.format('LT'),
  }));
  return slotsWithMetadata.reduce<RecurringCoachingSessionSlotGroupings>(
    (prev, curr) => {
      const { weekday, startTime } = curr;
      const existingStartTimes = prev[weekday];
      const existingSlots = existingStartTimes[startTime] ?? [];
      return {
        ...prev,
        [weekday]: {
          ...existingStartTimes,
          [startTime]: [...existingSlots, curr],
        },
      };
    },
    {
      Sunday: {},
      Monday: {},
      Tuesday: {},
      Wednesday: {},
      Thursday: {},
      Friday: {},
      Saturday: {},
    }
  );
}
